import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scrolls to the top of new pages (leaving browser scroll restoration intact for
 * Back/Forward) and announces route changes to screen readers.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();
  const [announcement, setAnnouncement] = useState("");
  const firstRender = useRef(true);

  useEffect(() => {
    if (navType === "POP") return; // let the browser restore the previous position
    if (hash) return; // anchor links handle their own destination
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navType]);

  useEffect(() => {
    if (firstRender.current) { firstRender.current = false; return; }
    const id = window.setTimeout(() => {
      setAnnouncement(`${document.title} — page loaded`);
    }, 250);
    return () => window.clearTimeout(id);
  }, [pathname]);

  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {announcement}
    </div>
  );
};

export default ScrollToTop;
